"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Env = void 0;
var three_1 = require("three");
var Env = /** @class */ (function () {
    function Env(base) {
        this.base = base;
        this.setLights();
    }
    Env.prototype.setLights = function () {
        this.setAmbientLight();
        this.setDirectionalLight();
        this.setBackground();
    };
    Env.prototype.setDirectionalLight = function () {
        this.directionalLight = new three_1.DirectionalLight(0xffffff, 1);
        this.directionalLight.castShadow = true;
        this.directionalLight.shadow.mapSize.set(2048, 2048);
        this.directionalLight.shadow.normalBias = 0.05;
        this.directionalLight.position.set(3.5, 2, -1.25);
        this.base.scene.add(this.directionalLight);
    };
    Env.prototype.setAmbientLight = function () {
        this.ambientLight = new three_1.AmbientLight(0xffffff, 1);
        this.base.scene.add(this.ambientLight);
    };
    Env.prototype.setBackground = function () {
        this.base.scene.background = this.base.resources.gradientCubeTexture;
    };
    Env.prototype.update = function (delta) {
    };
    return Env;
}());
exports.Env = Env;
